import { render, staticRenderFns } from "./ShipmentRelease.vue?vue&type=template&id=32803e9f"
import script from "./ShipmentRelease.vue?vue&type=script&lang=js"
export * from "./ShipmentRelease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports